import { HTMLAttributes } from 'react';
import { useTranslation } from '@sib/i18n';
import { Input, TOPBAR_HEIGHT } from '@sib/ui';
import { Search } from '@sib/ui/icons';
import { UserMenu } from './UserMenu';
import SibLogo from '/sidecar-logo.png';

export interface TopBarProps extends HTMLAttributes<HTMLElement> {}

export const TopBar = ({ ...props }: TopBarProps) => {
  const { t } = useTranslation();

  return (
    <header
      className="fixed top-0 right-0 left-0 z-50 flex w-screen items-center border-b bg-white pr-6 shadow-md"
      style={{ height: TOPBAR_HEIGHT }}
      {...props}
    >
      <div className="flex h-full w-13 items-center justify-center border-r border-gray-200 p-0.5">
        <img src={SibLogo} alt="Logo" />
      </div>
      <div className="flex-[1_1] items-center gap-2">
        <Input
          startAdornment={<Search className="size-4" />}
          className="hidden h-9 w-full max-w-3/10"
          placeholder={t('components.topbar.searchPlaceholder')}
          fullWidth
        />
      </div>
      <UserMenu />
    </header>
  );
};
